export default {"src":"https://s.sylndr.com/c-f6814a1/_next/static/media/recieve-sms-icon.e4124970.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};